// Used in pm.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ContentChange } from "ngx-quill";

// Services/Types/Helpers
import { Course } from "cli-types";
import { FormHelper } from "#core/helpers";

// Error State
import { MyErrorStateMatcher } from "./send-pm.errorstate";

@Component({
    selector: "send-pm",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./send-pm.component.html",
    styleUrls: [
        "../../notifications.component.scss",
        "./send-pm.component.scss",
    ],
    standalone: false
})
export class SendPmComponent implements OnInit {
    matcher = new MyErrorStateMatcher();

    @Input()
    courses?: Course[];

    @Output()
    newPm = new EventEmitter<Notification>();

    @Output()
    cancel = new EventEmitter<any>();

    pmForm?: UntypedFormGroup;
    working = false;

    // Toolbar configuration
    modules = {
        toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["link"],
            [{ align: [] }],

            ["clean"], // remove formatting button
        ],
    };

    constructor(private fb: UntypedFormBuilder, private formHelper: FormHelper) {}

    initForm() {
        this.pmForm = this.fb.group({
            body: [
                "",
                [
                    Validators.required,
                    this.formHelper.noQuillEditorWhitespaceValidator,
                ],
            ],
            title: ["", Validators.required],
            toUserID: ["", Validators.required],
        });
    }

    ngOnInit() {
        this.initForm();
    }

    sendPm() {
        if (this.pmForm?.valid) {
            this.working = true;
            this.newPm.emit(this.pmForm.value);
        }
    }

    setBody(editor: ContentChange) {
        if (this.pmForm) {
            // Force form to recalculate.
            this.pmForm.updateValueAndValidity();
        }
    }
}
